<template>
  <div class="pt-8 pb-20 flex-1 flex flex-col bg-white px-6">
    <div v-if="error">
      <p class="text-red-primary-700">{{ error }}</p>
    </div>
    <div v-else-if="card" class="flex flex-1 flex-col justify-center">
      <div class="w-full h-16 mb-6" v-if="company.logo">
        <img class="max-h-full mx-auto" :src="company.logo" />
      </div>

      <div class="flex justify-center">
        <loyalty-card class="w-full" :company="company" :loyaltyCard="card" />
      </div>
      <div class="pb-6">
        <div class="mt-8 text-sm px-6 text-center">
          <p class="text-gray-800 text-2xl font-semibold">
            {{ $t("dashboard.just_used_invitation") }}
            <span class="text-yellow-primary-500">{{
              $t("global.loyalty_card")
            }}</span
            ><br />
            {{ company.brand }}
          </p>
        </div>
      </div>

      <div class="mt-4 mb-8 text-center">
        <router-link
          :to="{
            name: $route.query.redirect
              ? $route.query.redirect
              : 'loyalty-card-show',
            params: { id: card.id },
            query: { wallet: this.openAskDownloadPass }
          }"
          class="px-12 text-white bg-blue-primary-500 rounded-lg py-3.5 border border-transparent"
        >
          <span>Ok</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import LoyaltyCard from "@/components/Cards/LoyaltyCard";

import loyaltyCardApi from "@/api/loyalty-card";

export default {
  components: {
    LoyaltyCard
  },

  data() {
    return {
      cardUuid: null,
      card: null,
      error: null,
      openAskDownloadPass: false
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("global", ["isIos"]),

    company() {
      return this.card ? this.card.loyaltyProgram.company : null;
    }
  },

  mounted() {
    this.cardUuid = this.$route.params.id;
    this.getLoyaltyCard();
  },

  methods: {
    getLoyaltyCard() {
      loyaltyCardApi
        .getOneCard(this.cardUuid, {
          include:
            "loyaltyProgram.company,loyaltyProgram,loyaltyProgram.locations"
        })
        .then(res => {
          this.card = res.data;
          if (this.isIos) {
            this.openAskDownloadPass = true;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.error = this.$t("dashboard.invitation_not_found");
        });
    }
  }
};
</script>
